// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/chunks/" + ({"200":"insights","328":"postMetrics","1275":"search-insights","3524":"app"}[chunkId] || chunkId) + "-" + {"200":"4b120576","328":"e29187f6","1275":"fe2ea4ca","3524":"860c6f46","7482":"43f97571"}[chunkId] + ".css";
};